import React from "react";
import { redirect } from "react-router-dom";
import UserPortal from "../organisms/UserPortal";
import TransitionWrapper from "../atoms/TransitionWrapper";
import UseLandingLoader from "../../hooks/useLandingLoader";
import { getAuthToken, removeAuthToken } from "../../utils/helper/token";
const UserPortalPage = () => {
  UseLandingLoader();
  return (
    <TransitionWrapper>
      <UserPortal />
    </TransitionWrapper>
  );
};

export const loader = async () => {
  const token = getAuthToken();
  if (!token) {
    return null;
  }
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/user/auth`,
    {
      method: "GET",
      headers: {
        "x-access-token": token,
      },
    }
  );
  if (!response.ok) {
    removeAuthToken();
    return null;
  } else {
    return redirect("/");
  }
};

export default UserPortalPage;
